import { SearchFilters } from '@rover/types';
import { snakeifyString } from '@rover/rsdk/src/modules/Network/object-utilities';

const getDogSizes = (params?: Partial<SearchFilters>): string => {
  if (!params) {
    return '';
  }

  const allDogSizes = ['smallDogs', 'mediumDogs', 'largeDogs', 'giantDogs'];
  const dogSizes: string[] = [];
  allDogSizes.forEach((size) => {
    if (params[size]) {
      dogSizes.push(snakeifyString(size));
    }
  });
  return dogSizes.join(', ');
};

export default getDogSizes;
